<template>
    <IndexHeader />
    <div class="middlebar" form="[object Object]" layouttype="2">
        <div class="middle-con">
            <!---->
            <div class="m-img"><img :src="data.orgInfo.logo" alt=""></div>
            <div><span class="teacher-name">{{ data.accountInfo.nickName }}</span></div>
            <div class="border-middle">
                <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAVYAAAABCAQAAAAvWk7zAAAAYUlEQVQoz9VRMRKAIAyLm///rmfioNK0lM1FuAMScm0Im4R/DH12I9sFgM9JLTNPDk2PNJBAY7ImuNC8tRyz1TqqaoA4JwfZS3XKJYviNt4cjmW9V6lFqp5vXvt/u9GB/QJIE7wN7igy/wAAAABJRU5ErkJggg=="
                    alt="">
            </div>
            <!-- <div>
                <span class="teacher-account">账号：{{  }}</span>
            </div> -->
        </div>
    </div>
</template>
<script setup>
// 首页顶部导航栏
import IndexHeader from "../components/IndexHeader/TopBar";
import { reactive } from "vue";
import { requestToken } from "../common/js/request_token"
import { getUserInfo } from "../server/user_center_info";

const isLogin =  requestToken() !== "";

if(isLogin){
    fetchUserInfo() 
}
const data = reactive({
    accountInfo:{},
    orgInfo: {},
})
async function fetchUserInfo() {
    let info = await getUserInfo();
    if (info != false) {
        data.accountInfo = info.accountInfo
        data.orgInfo = info.orgInfo
    }
}
</script>
<style scoped>
    .middlebar{
        margin-top: 64px;
    }
</style>